<template>
  <div>
    <f7-accordion-item class="accordionForm" @accordion:open="openedAccordion=true"
      @accordion:opened="openedFinishedAccordion=true"
      @accordion:close="openedAccordion=openedFinishedAccordion=false" :expanded="open">
      <f7-accordion-toggle class="accordionToggle">
        <div class="form-group row justify-content-start">
          <div class="col-sm-auto titleUnderline"
            :class="[(isTitleUpperCase ? 'text-uppercase' : ''), (isTitleBold ? 'font-weight-bold' : '')]">
            {{ title }}
            <span v-if="star" class="color-red"> *</span>
            <i class="f7-icons formChevron" :style="{color: chevron_color}"
              v-if="openedAccordion">{{ chevron_open }}
            </i>
            <i class="f7-icons formChevron" :style="{color: chevron_color}"
              v-if="!openedAccordion">{{ chevron_close }}
            </i>
          </div>
        </div>
      </f7-accordion-toggle>
      <f7-accordion-content :class="{accordionContentExpended: openedFinishedAccordion}">
        <slot></slot>
      </f7-accordion-content>
    </f7-accordion-item>
  </div>
</template>

<script>
export default {
  name: 'FormAccordion',
  props: {
    title: {
      type: String
    },
    open: {
      type: Boolean,
      default: true
    },
    star: {
      type: Boolean,
      default: false
    },
    hasDatePicker: {
      type: Boolean,
      default: false
    },
    chevron_open: {
      type: String,
      default: 'chevron_down'
    },
    chevron_close: {
      type: String,
      default: 'chevron_right'
    },
    chevron_color: {
      type: String,
      default: '#6593f5'
    },

    isTitleUpperCase: {
      type: Boolean,
      default: true
    },

    isTitleBold: {
      type: Boolean,
      default: true
    }

  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      chevronColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id),
      openedAccordion: this.open,
      openedFinishedAccordion: this.open
    }
  },
  computed: {
    renderOpenClass () {
      return this.open ? 'accordion-item-expanded' : ''
    }
  },
  watch: {
    open () {
      this.openedAccordion = this.open
    }
  }
}
</script>

<style lang="css" scoped>
.collapsed > .when-open,
:not(.collapsed) > .when-closed {
  display: none;
}

.collapsed > .when-closed,
:not(.collapsed) > .when-open {
  display: inline;
}
.accordionToggle:hover {
  cursor: pointer;
}

.titleUnderline:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// FormAccordion.vue?6a50b046